webpackJsonp([162898551421021],{

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    _layout.FrameContainer,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '404 Not Found'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3002\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002'
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-d3fa5db9f9111f9fecc3.js